var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AdClientFormBase',{attrs:{"ad-client-entry":_vm.adClientEntry,"save-loading-entry":_vm.editLoading,"is-edit-form":""},on:{"item:submit":_vm.submitEventHandler}})}
var staticRenderFns = []

export { render, staticRenderFns }